import {
  Box,
  Drawer,
  useTheme,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { SVGProps, useState } from "react";
import CircleButton from "../../../ui/CircleButton";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../hooks/useAuth";
import BasicTransactionForms from "../../../forms/basic-transactions/BasicTransactionForms";
import { CloseIcon } from "../../../ui/icons";

const ButtonIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25" fill="#FBE290" />
      <path d="M25.087 46.884c11.972 0 21.677-9.706 21.677-21.678 0-11.971-9.705-21.677-21.677-21.677S3.41 13.235 3.41 25.207c0 11.971 9.705 21.677 21.677 21.677" fill="#F9CE46" />
      <path d="M37.29 26.29c-6.771 2.02-9.312 4.505-11.377 11.132-.363 1.164-2.052 1.164-2.415 0-2.065-6.627-4.606-9.112-11.377-11.133-1.195-.357-1.195-2.002 0-2.359 6.771-2.021 9.312-4.506 11.377-11.133.363-1.164 2.052-1.164 2.415 0 2.065 6.627 4.606 9.112 11.377 11.133 1.195.357 1.195 2.003 0 2.36" fill="#fff" />
    </svg>

  );
};

const ButtonCreateTransaction = ({
  circleButton = true,
}: {
  circleButton?: boolean;
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  const { t } = useTranslation("common");
  const [openCreateTransaction, setOpenCreateTransaction] = useState(false);

  const handleCloseDrawer = () => {
    setOpenCreateTransaction(false);
  };

  const button = circleButton ? (
    <Box
      sx={{
        right: 20,
        bottom: 20,
        position: "fixed",
      }}
      data-onboarding-id="onboarding-add-transaction"
    >
      <CircleButton
        color={theme.palette.yellow[500]}
        onClick={() => setOpenCreateTransaction(true)}
        aria-label={t("transactions.add_transaction")}
        size={50}
      >
        <ButtonIcon />
      </CircleButton>
    </Box>
  ) : (
    <Button
      fullWidth
      color="primary"
      variant="outlined"
      onClick={() => setOpenCreateTransaction(true)}
      aria-label={t("transactions.add_transaction")}
      size="large"
    >
      {t("transactions.add_transaction")}
    </Button>
  );

  return (
    <>
      {user && button}

      {/* Transaction Drawer */}
      <Drawer
        anchor="right"
        open={openCreateTransaction}
        onClose={handleCloseDrawer}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "100%", sm: 400 },
            maxWidth: "100%",
            boxSizing: "border-box",
            overflow: "auto",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
            }}
          >
            <Typography variant="h6" fontWeight="bold">
              {t("transactions.create_transaction")}
            </Typography>
            <IconButton
              onClick={handleCloseDrawer}
              size="large"
              sx={{ color: "inherit" }}
              aria-label={t("close")}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          </Box>

          <BasicTransactionForms
            isDrawer
            handleCloseDrawer={handleCloseDrawer}
          />
        </Box>
      </Drawer>
    </>
  );
};

export default ButtonCreateTransaction;
